<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Seleção de módulo"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox-group
                        :validations="validations.modulo"
                        label="Módulos"
                        v-model="model.modulos"
                    >
                        <rkm-row>
                            <rkm-col
                                v-for="modulo in form.modulos"
                                :key="modulo.id"
                                cols="4"
                            >
                                <rkm-form-checkbox :value="modulo.id">{{modulo.nome}}</rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="openScreen"
                color="primary"
            >
                Abrir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                modulo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('painelSenha.parametrizacao'),
        }
    },
    data: () => ({
        form: {
            modulos: []
        },
        model: {
            modulos: [],
            telaId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.resetForm()

            this.form.modulos = item.modulos
            this.model.telaId = item.id

            this.$refs.RkmModal.show()
        },
        openScreen() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    let params = {
                        name: 'painel-senha-tela-show',
                        params: {id: this.model.telaId},
                    }

                    if (this.model.modulos && this.model.modulos.length > 0) {
                        params.query = {modulos: this.model.modulos}
                    }

                    const route = this.$router.resolve(params)

                    window.open(route.href, '_blank')

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.form.modulos = []
            this.model.modulos = []

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, repository, stringCase],
}
</script>